var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleCheckmarkLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 39,
  height: 39,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 19.5,
  r: 19.5,
  fill: "#00BAC6"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 20.429 16.4 26 29 13",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgCircleCheckmarkLarge as ReactComponent };
export default __webpack_public_path__ + "39fd8b72dd19938fb913c6685fee1e9d.svg";